import React, { useEffect} from 'react';//, useState 
import { useDispatch } from 'react-redux';//, useSelector
//import { closeMessageBox,  openMessageBox } from  '../../store/main/actions';

import {
    btnSearch,
    onExport
  
} from '../../store/movilidad/aprobarpedido/actions';

import { Body, Footer, Page } from '@sigeco/tools';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';

import AprobarPedidoFilter from '../../components/movilidad/aprobarpedido/AprobarPedidoFilter';
import AprobarPedidoList from '../../components/movilidad/aprobarpedido/AprobarPedidoList';

const AprobarPedido = ({onClose, setTitle}) => {
    
    const dispatch = useDispatch();


    useEffect(() => {
        setTitle('Aprobar Pedidos');
    // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        onClose();
    }

    return (
        <Page>
            <Backdrop style={{ position: 'absolute', zIndex: 1200 }} open={false} transitionDuration={0}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Body>
            <AprobarPedidoFilter />
            <AprobarPedidoList />
        </Body>
        <Footer>
            <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(onExport())}
                    startIcon={<Icon className="fas fa-file-excel"/>}
                  >
                    Exportar
            </Button>

            <Button
                color="primary"
                size="small"
                variant="outlined"
                onClick={() => dispatch(btnSearch())}
                    startIcon={<Icon className="fas fa-search"/>}
                >
                Buscar
            </Button>
            <Button 
                color="primary" 
                size="small" 
                variant="outlined" 
                onClick={() => onBtnClose()} 
                startIcon={<Icon className="fas fa-door-open"/>}
            >
                Salir
            </Button>
        </Footer>
        </Page>
    )
};

export default AprobarPedido;